import { render, staticRenderFns } from "./TelegramNotification.vue?vue&type=template&id=9d7c5ed8&"
import script from "./TelegramNotification.vue?vue&type=script&lang=js&"
export * from "./TelegramNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports